module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 227
// module chunks = 3